import {GridWidgetDataField} from './grid-widget-data-field';
import {TextFilter} from './text-filter';
import {OrderedMap} from '../ordered-map';
import {ComparatorSetting} from './grid-widget-filter';

export interface TextFieldComparatorVisibility {
  IS_BLANK?: boolean;
  CONTAINS?: boolean;
}

export class TextField extends GridWidgetDataField {

  validationRules: TextFieldValidationRules;

  comparatorSettings: OrderedMap<ComparatorSetting> = new OrderedMap<ComparatorSetting>();

  showComparators = false;

  constructor(name: string, objectLookup: string | ((Object) => any), title: string, sortOrder?: any) {
    super(name, objectLookup, title, sortOrder);
    this.comparatorSettings.putAll([
      { key: 'CONTAINS', value: { comparator: 'CONTAINS', isVisible: true, messageKey: 'pds|grid widget|contains'} },
      { key: 'IS_BLANK', value: { comparator: 'IS_BLANK', isVisible: false, messageKey: 'pds|grid widget|is blank'} }
    ]);
  }

  getFilterInstance(): TextFilter {
    return new TextFilter(this);
  }

  setValidationRules(rules: TextFieldValidationRules): void {
    this.validationRules = rules;
  }

  /**
   * This is how the using developer turns on and off the comparator settings.
   * Comparators are the ones that show up in the drop down and hold things like
   * "is blank" or "contains"
   */
  setComparatorVisibility(visibility: TextFieldComparatorVisibility): void {
    for (let key of Object.keys(visibility)) {
      let setting: ComparatorSetting | undefined = this.comparatorSettings.get(key);
      if (setting != null) {
        setting.isVisible = visibility[key];
      }
    }

    let numVisible = 0;
    for (let item of this.comparatorSettings.array) {
      if (item.value.isVisible) {
        numVisible++;
      }
    }

    this.showComparators = numVisible >= 2;
  }

  resolveAsString(dataRow: any): string {
    return <string>this.resolve(dataRow) || '';
  }
}

export type TextFieldValidationRules = {
  'data-customvalidate'?: string,
  'data-excludechars'?: string,
  'data-maxlength'?: string,
  'data-minlength'?: string,
  'data-regex'?: string,
  'data-regex-error-text'?: string
};
